module.exports = __webpack_public_path__ + "media/images/workplace/intro-page/step1-2-p-23df06948a430101b5a19038af90851d.gif";